import React from 'react'
import HttpServices from '../../../utils/Http.services'
import { checkTextTranslation, imageAddress, translate } from '../../../utils/useful'
// import { widgetsList } from '../../../variables/widgetsList'


class SecondStep extends React.Component {

    state = {

        list: []
    }

    componentDidMount() {
        // this.getAllApplets()
        console.log("LOGG", this.props.widgetsList)
        let applet = this.props.initData?.applet
        console.log('applet', applet)
        let list = []
        if (applet && applet.features) {
            applet.features.forEach(feature => {
                Object.values(this.props.widgetsList).forEach(widget => {
                    if (widget.features && widget.features.includes(feature)) {
                        list.push(widget)
                    }

                });
            });
        }

        this.setState({ list })
    }
    nextPage = (item) => {
        this.props.setData(({ widget: item }), () => {
            // this.props.setData(({ applet: item }) => {

            this.props.changeStage('thirdstep')

        })

    }

    handleSearchBox = (e) => {
        this.setState({ search: e }, () => {
            console.log('this is search:', this.state.search)
            this.searchList()
        })
    }

    searchList = () => {
        let data = [...this.state.list]

        if (!this.state.fulldata) {
            this.setState({ fulldata: data })
        } else {
            data = this.state.fulldata
        }
        // console.log('data 1', data)
        let temp = []
        // console.log('temp', temp)


        for (let i = 0; i < data.length; i++) {
            console.log('data 2', data[i])
            let content = data[i];
            console.log('content', content)
            if (checkTextTranslation(content?.title).toLowerCase().includes(this.state.search.toLowerCase())) {
                temp.push(content)
            }
        }

        console.log(temp)
        this.setState({ list: temp });



    }

    render() {
        const { widgetsList } = this.props
        return (
            <div className="w-100 h-100 scroll-no-scrollbar">

                <div className="px-2 w-100 py-2 position-sticky top-0" style={{ background: 'linear-gradient(to right , #4685cccb,#4646cc)', backgroundColor: '#4646cc' }}>
                    <div className="mb-2">
                        <button onClick={() => this.props.lastStage()} className='flexc'>
                            <div className='rotate-180  br-50 ws-25 hs-25 flexcc' style={{ background: '#ffffffcd' }}>
                                <img className='' src="/assets/icons/useful/angle-right.svg" height={20} />
                                {/* <img className='invert' src="/assets/icons/useful/fi-sr-angle-left.png" height={20} /> */}
                            </div>
                            <h2 style={{ color: '#ffffffcc', fontSize: 19 }} className="   mx-2" >{translate('Select Widgets')}</h2>
                        </button>
                        {/* <p style={{ color: '#fff' }}>
                            {translate('Select Widgets')}
                        </p> */}
                    </div>
                    <div >
                        <div style={{ backgroundColor: '#f6f6f6', borderRadius: 6 }}>
                            <input className="py-1 px-2 w-100" onChange={(e) => this.handleSearchBox(e.target.value)} placeholder={translate('Search ...')} style={{ backgroundColor: 'transparent', border: 'none' }} />
                        </div>
                    </div>
                </div>
                <div className="w-100 mt-2 d-flex flex-wrap">
                    {this.state.list.length == 0 ? (
                        <div className='flexcc w-100 mt-4'>
                            <p>found Nothing</p>
                        </div>
                    ) : (


                        this.state.list.map((prop, index) => {
                            return (
                                <button key={index} className="w-50 px-2 my-2 flex-column d-flex align-items-center text-start" onClick={() => this.nextPage(prop)}>
                                    {console.log('list', prop.types[0].img)}
                                    <div>
                                        {/* <img src={prop.icon} width="40px" /> */}
                                        <img src={prop?.types ? prop.types[0].img : ''} style={{ borderRadius: 11 }} width="120px" />
                                    </div>
                                    <div className="mld-4">
                                        <p className="text-normal text-bold">{prop.title}</p>
                                        {/* <p className="text-smaller">this is the description of module</p> */}
                                    </div>
                                </button>
                            )
                        })

                    )}
                </div>
            </div>
        );
    }
}

export default SecondStep;